import { useId } from 'react';

export const VaultIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  const gradientId = useId();

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="48" height="48" rx="8" fill={`url(#${gradientId})`} />

      <path
        d="M38.7771 9H12.706C12.0307 9 11.4831 9.5524 11.4831 10.2337V16.2977H9.22293C8.54757 16.2977 8 16.8501 8 17.5314C8 18.2128 8.54757 18.7651 9.22293 18.7651H11.4831V26.4132H9.22293C8.54757 26.4132 8 26.9656 8 27.647C8 28.3283 8.54757 28.8807 9.22293 28.8807H11.4831V34.9447C11.4831 35.626 12.0307 36.1784 12.706 36.1784H16.4177V37.7663C16.4177 38.4476 16.9653 39 17.6407 39C18.316 39 18.8636 38.4476 18.8636 37.7663V36.1784H32.6194V37.7663C32.6194 38.4476 33.167 39 33.8423 39C34.5177 39 35.0653 38.4476 35.0653 37.7663V36.1784H38.7771C39.4524 36.1784 40 35.626 40 34.9447V10.2337C40 9.5524 39.4524 9 38.7771 9ZM37.5541 33.711H13.929V11.4674H37.5541V33.711Z"
        fill="white"
      />
      <path
        data-nav-part="vault-dial"
        d="M19.518 23.823H20.7657C21.2192 25.684 22.6738 27.1514 24.5186 27.609V28.8677C24.5186 29.549 25.0662 30.1014 25.7416 30.1014C26.4169 30.1014 26.9645 29.549 26.9645 28.8677V27.609C28.8093 27.1515 30.2638 25.684 30.7175 23.823H31.9651C32.6405 23.823 33.1881 23.2706 33.1881 22.5892C33.1881 21.9079 32.6405 21.3555 31.9651 21.3555H30.7175C30.264 19.4945 28.8093 18.0271 26.9645 17.5695V16.3108C26.9645 15.6295 26.4169 15.0771 25.7416 15.0771C25.0662 15.0771 24.5186 15.6295 24.5186 16.3108V17.5695C22.6738 18.027 21.2193 19.4945 20.7657 21.3555H19.518C18.8426 21.3555 18.295 21.9079 18.295 22.5892C18.295 23.2706 18.8425 23.823 19.518 23.823ZM25.7408 19.887H25.7415C25.7415 19.887 25.7419 19.887 25.7421 19.887C27.2188 19.8873 28.42 21.0994 28.42 22.5891C28.42 24.0792 27.2183 25.2914 25.7414 25.2914C24.2647 25.2914 23.0631 24.0795 23.0628 22.5899C23.0628 22.5897 23.0628 22.5895 23.0628 22.5892C23.0628 22.589 23.0628 22.5888 23.0628 22.5886C23.0633 21.099 24.2644 19.8874 25.7408 19.887Z"
        fill="white"
      />

      <defs>
        <linearGradient
          id={gradientId}
          x1="5"
          y1="3.5"
          x2="41.5"
          y2="48"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.087" stopColor="#F7D979" />
          <stop offset="0.5556" stopColor="#F0B90B" />
          <stop offset="0.939" stopColor="#D39E09" />
        </linearGradient>
      </defs>
    </svg>
  );
};
